import { createReducer, on } from '@ngrx/store';
import * as ReferentielActions from './referentiel.actions';
import { ReferentielState, initialReferentielState } from './referentiel.state';

export const referentielReducer = createReducer(
  initialReferentielState,

  // Languages
  on(ReferentielActions.loadLanguages, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ReferentielActions.loadLanguagesSuccess, (state, { languages }) => ({
    ...state,
    languages,
    loading: false,
  })),
  on(ReferentielActions.loadLanguagesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Services
  on(ReferentielActions.loadServices, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ReferentielActions.loadServicesSuccess, (state, { services }) => ({
    ...state,
    services,
    loading: false,
  })),
  on(ReferentielActions.loadServicesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Insurers
  on(ReferentielActions.loadInsurers, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ReferentielActions.loadInsurersSuccess, (state, { insurers }) => ({
    ...state,
    insurers,
    loading: false,
  })),
  on(ReferentielActions.loadInsurersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  
  // Countries
  on(ReferentielActions.loadCountries, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ReferentielActions.loadCountriesSuccess, (state, { countries }) => ({
    ...state,
    countries,
    loading: false,
  })),
  on(ReferentielActions.loadCountriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
